module.exports = __webpack_public_path__ + "img/idea-score-latest.1ffd6532.svg";